export var RECALL_STATUS = {
  CLOSED: 'CLOSED',
  OPEN: 'OPEN'
};
export var JOB_STATUS = {
  NOT_STARTED: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  VOID_INITIATED: 'VOID_INITIATED',
  VOID: 'VOIDED'
};